import React from 'react'

const AppRoute = ({ component: Component, routeKey, ...props }) => {
  return <Component routeKey={routeKey} {...props} />
}

export default AppRoute
